import "./index.css";

import { showCrashDialog } from "./CrashHandling";
import { startHexGrip } from "./HexGrip";
import reportWebVitals from "./reportWebVitals";

try {
  const loading = document.getElementById("loading");
  if (loading !== null) {
    document.body.removeChild(loading);
  }
  startHexGrip();
} catch (err) {
  showCrashDialog({
    error: err
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
